import * as tslib_1 from "tslib";
import { Apollo } from 'apollo-angular';
import { GET_LOCATION_ENVIRONMENT_MAINTENANCES_QUERY } from './location-sectors.query';
import * as i0 from "@angular/core";
import * as i1 from "apollo-angular";
var TabMaintenancesService = /** @class */ (function () {
    function TabMaintenancesService(apollo) {
        this.apollo = apollo;
    }
    TabMaintenancesService.prototype.getEnvironmentMaintenances = function (_a) {
        var id = _a.id, take = _a.take, after = _a.after;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_b) {
                return [2 /*return*/, this.apollo
                        .query({
                        query: GET_LOCATION_ENVIRONMENT_MAINTENANCES_QUERY,
                        variables: { id: id, take: take, after: after }
                    })
                        .toPromise()
                        .then(function (_a) {
                        var data = _a.data;
                        return data['locationEnvironment']['maintenances'];
                    })];
            });
        });
    };
    TabMaintenancesService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function TabMaintenancesService_Factory() { return new TabMaintenancesService(i0.ɵɵinject(i1.Apollo)); }, token: TabMaintenancesService, providedIn: "root" });
    return TabMaintenancesService;
}());
export { TabMaintenancesService };
